import { defineStore } from 'pinia'
import type {
  MicrosoftMember,
  MicrosoftMembersRequest,
  MicrosoftTenantResponse,
  WorkspacePreferencesAuthProviderEnum,
} from '@apiTypes'
import api from '@api'
import { useAuthStore } from '@store/auth'

interface SocialState {
  microsoftTenant: MicrosoftTenantResponse | null
  accessDenied: boolean
  microsoftUsersSelected: MicrosoftMember[] | null
  selectedProvider: WorkspacePreferencesAuthProviderEnum | null
}

export const useSocialStore = defineStore('social', {
  state: (): SocialState => ({
    microsoftTenant: null,
    accessDenied: false,
    microsoftUsersSelected: null,
    selectedProvider: null,
  }),
  getters: {
    hasMicrosoftTenant: state => state.microsoftTenant !== null,
    isAccessDenied: state => state.accessDenied,
    getMicrosoftUsersSelected: state => state.microsoftUsersSelected,
    getSelectedProvider: state => state.selectedProvider || useAuthStore().currentWorkspace?.preferences?.authProvider,
  },
  actions: {
    setMicrosoftTenant(tenant: MicrosoftTenantResponse) {
      this.microsoftTenant = tenant
    },

    setAccessDenied() {
      this.accessDenied = true
    },

    setMicrosoftUsersSelected(users: MicrosoftMember[]) {
      this.microsoftUsersSelected = users
    },
    setSelectedProvider(provider: WorkspacePreferencesAuthProviderEnum) {
      this.selectedProvider = provider
    },

    fetchMicrosoftUsersSelected(data: MicrosoftMembersRequest) {
      return api.microsoftGraph.microsoftGraphMembersCreate(data).then(response => {
        this.setMicrosoftUsersSelected(response.data)

        return response
      })
    },

    clearTenantInfo() {
      this.microsoftTenant = null
      this.accessDenied = false
      this.microsoftUsersSelected = null
      this.selectedProvider = null
    },
  },
})
